import React from 'react';
import anchorme from 'anchorme';
import BlockContainer from '../BlockComponents/BlockContainer';
import BlockContentContainer from '../BlockComponents/BlockContentContainer';
import BlockTextContainer, { BlockSubTextContainer } from '../BlockComponents/BlockTextContainer';
import { IPaymentBlockPreviewProps } from './IPaymentBlockPreviewProps';
import './PaymentBlockPreview.scss';
import miscUtils from 'utils/miscUtils';
import { ButtonAction, PaymentBlockPurpose, scrollElementIntoView, SellableTypes, UpsellUrgencyType } from 'containers/PageBuilder/SinglePageContainer/domain';
import Login from 'containers/login';
import useForm from 'utils/validator/validator';
import { AuthorizeService } from 'api/services/authorize';
import { User } from 'core/models/users';
import Cookie from "js-cookie";
import { CommonConstants } from 'constants/common';
import Button from 'elements/button/Button';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import publicIp from "public-ip";
import { deviceDetect } from "react-device-detect";
import PurchaseLoginModal from 'containers/AppPurchase/PurchaseLoginModal';
import { ReactComponent as VisaIcon } from 'containers/AppPurchase/icons/credit-card/visa-card.svg';
import { ReactComponent as MasterCardIcon } from 'containers/AppPurchase/icons/credit-card/master-card.svg';
import { ReactComponent as AmexIcon } from 'containers/AppPurchase/icons/credit-card/american-express.svg';
import { ReactComponent as DiscoverIcon } from 'containers/AppPurchase/icons/credit-card/discover.svg';
import { ReactComponent as DinersClubIcon } from 'containers/AppPurchase/icons/credit-card/diners-club.svg';
import { Elements, StripeProvider } from "react-stripe-elements";
import PaymentDetails from 'containers/AppPurchase/PaymentDetails';
import appConfig from 'appConfig';
import PlanSelectionStripeForm from 'containers/PlanSelection/PlanSelectionStripeForm';
import { GroupService } from 'api/services/groups';
import PricingService from 'api/services/pricing';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { GroupAppResource } from 'containers/LockScreen/domain';
import BlockButton from '../BlockComponents/BlockButton';
import { ReactComponent as CheckIcon } from './icons/check.svg';
import { ReactComponent as DangerIcon } from './icons/danger.svg';
import { ReactComponent as UnavailableIcon } from './icons/unavailable.svg';
import TurnstileWidget from 'components/TurnstileWidget/TurnstileWidget';
import { useAtom } from 'jotai';
import { isHumanVerifiedAtom } from 'showMessageMenuAtom';
import { useTurnstile } from 'react-turnstile';
import styled from 'styled-components';
import { isValidHexColor } from 'components/PageBuilder/PageBuilderSideBar/BlockSettings/domain';
import { isPastEvent } from 'containers/events/components/EventsListItem/CommunityEventsListItem/utils';

dayjs.extend(utc);
dayjs.extend(timezone);

interface INewUserDetails {
    full_name?: string;
    email: string;
    password: string;
    group_id?: string;
  session_token?: string
}

const SECONDS_IN_A_MINUTE = 60;
const MILLISECONDS_IN_A_SECOND = 1000;

const SkipUpsellContainer = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SkipUpsellText = styled.p<{design: any}>`
	margin: 0;
	padding: 0;
	cursor: pointer;
	font-size: ${(props: any) =>
			props.design.skip_upsell_text_font_size &&
			props.design.skip_upsell_text_font_size <= 50 ?
			`${props.design.skip_upsell_text_font_size}px` :
			`15px`
		};
		line-height: ${(props: any) =>
			props.design.skip_upsell_text_line_height &&
			props.design.skip_upsell_text_line_height <= 50 ?
			`${props.design.skip_upsell_text_line_height}px` :
			`18px`
		};
		font-family: ${(props: any) =>
			props.design.skip_upsell_text_font_family ?
			`${props.design.skip_upsell_text_font_family} !important` :
			`-apple-system, Arial !important`
		};
		color: ${(props: any) => 
			props.design.skip_upsell_text_color &&
			isValidHexColor(props.design.skip_upsell_text_color) ?
			props.design.skip_upsell_text_color :
			'#000000'
		};
`;

const UpsellTimerContainer: any = styled.div<{design: any}>`
    background-color: ${(props: any) =>
      props.design.upsell_timer_background_color &&
      isValidHexColor(props.design.upsell_timer_background_color) ?
      props.design.upsell_timer_background_color :
      '#FFFFFF'
    };
`;

const UpsellTimerIconContainer: any = styled.span<{design: any}>`
    svg {
      g {
        path {
          stroke: ${(props: any) => 
            props.design.upsell_timer_icon_color &&
            isValidHexColor(props.design.upsell_timer_icon_color) ?
            props.design.upsell_timer_icon_color :
            '#C03131'
          };
        }
        
        circle {
          fill: ${(props: any) => 
            props.design.upsell_timer_icon_color &&
            isValidHexColor(props.design.upsell_timer_icon_color) ?
            props.design.upsell_timer_icon_color :
            '#C03131'
          };
        }
      }
    }
`;

const UpsellTimerText: any = styled.p<{design: any}>`
      font-size: ${(props: any) =>
          props.design.upsell_timer_text_font_size &&
          props.design.upsell_timer_text_font_size <= 50 ?
          `${props.design.upsell_timer_text_font_size}px` :
          `15px`
      };
      line-height: ${(props: any) =>
          props.design.upsell_timer_text_line_height &&
          props.design.upsell_timer_text_line_height <= 50 ?
          `${props.design.upsell_timer_text_line_height}px` :
          `18px`
      };
      font-family: ${(props: any) =>
          props.design.upsell_timer_text_font_family ?
          `${props.design.upsell_timer_text_font_family} !important` :
          `-apple-system, Arial !important`
      };
      color: ${(props: any) => 
          props.design.upsell_timer_text_color &&
          isValidHexColor(props.design.upsell_timer_text_color) ?
          props.design.upsell_timer_text_color :
          '#000000'
      };
`;

const PaymentBlockPreview: React.FC<IPaymentBlockPreviewProps> = (props) => {
  const [isHumanVerified, setisHumanVerified] = useAtom(isHumanVerifiedAtom) as any;
  const turnstile = useTurnstile();
  const turnstileWidgetIsAvailable = document.getElementById('cloudflaire-turnstile-widget');

    const [seconds, setSeconds] = React.useState(() => {
        if(
            props.blockData.purpose === PaymentBlockPurpose.Upsell &&
            props.blockData.upsell_urgency_type === UpsellUrgencyType.Timer &&
            props.blockData.upsell_urgency_value
        ) {
            return props.blockData.upsell_urgency_value * SECONDS_IN_A_MINUTE;
        }

        return 0;
    });
    const [displayDate, setDisplayDate] = React.useState<any>({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    const [isCheckingEmailEntered,] = React.useState<boolean>(false);
    const [userIsFound,] = React.useState<string>();
    const [showNameInput,] = React.useState<boolean>(true);
    const [makingPurchase, setMakingPurchase] = React.useState<boolean>(false);
    const [newUserDetails, setNewUserDetails] = React.useState<INewUserDetails>({
        full_name: "",
        email: "",
        password: "",
        group_id: props.group && props.group.id
    });
    const [communityTheme,] = React.useState(props.group.custom_branding);
    const [ua, setUa] = React.useState<string>('');
    const [ip, setIp] = React.useState<string>('');
    const [isLoginModalOpen, setIsLoginModalOpen] = React.useState<boolean>(false);
    const [updateCard, setUpdateCard] = React.useState<boolean>(false);
    const [paymentData, setPaymentData] = React.useState<any>();
    const [validCoupon, setValidCoupon] = React.useState<any>(null);
    const [userMayHaveCoupon, setUserMayHaveCoupon] = React.useState<boolean>(false);
    const [couponCode, setCouponCode] = React.useState<string>("");
    const [isValidatingCoupon, setIsValidatingCoupon] = React.useState<boolean>(false);
    const [isTosChecked, setIsTosChecked] = React.useState<boolean>(false);
    const [isFreePlan, setisFreePlan] = React.useState<boolean>(false);
    const [isAnUpsellResourcePurchased, setIsAnUpsellResourcePurchased] = React.useState<boolean>(false);
    const [loadingIsResourcePurchased, setLoadingIsResourcePurchased] = React.useState<boolean>(() => {
      return (
        !props.buildingPreview &&
        !props.preview &&
        !!props.authedUser
      )
    });
    const [isResourcePurchased, setIsResourcePurchased] = React.useState<boolean>(false);
    const [purchaseSuccessful, setPurchaseSuccessful] = React.useState<boolean>(false);
    const [trialDays, setTrialDays] = React.useState<number>(0);
    const [loadingTrialDays, setLoadingTrialDays] = React.useState<boolean>(false);
    const [isBlockValid, setIsBlockValid] = React.useState<boolean>(false);

    let userId = props.authedUser && props.authedUser.id;

    React.useEffect(() => {
      if(
        (
          props.preview ||
          props.buildingPreview
        ) ||
        (
          props.blockData &&
          props.blockData.purpose !== PaymentBlockPurpose.Upsell
        ) ||
        (
          props.blockData && 
          props.blockData.purpose === PaymentBlockPurpose.Upsell &&
          !props.blockData.upsell_urgency_type
        ) ||
        (
          props.blockData && 
          props.blockData.purpose === PaymentBlockPurpose.Upsell &&
          props.blockData.upsell_urgency_type === UpsellUrgencyType.None
        ) ||
        (
          props.blockData && 
          props.blockData.purpose === PaymentBlockPurpose.Upsell &&
          props.blockData.upsell_urgency_type &&
          props.blockData.upsell_urgency_type !== UpsellUrgencyType.None &&
          localStorage.getItem('from_purchase_page') &&
          localStorage.getItem('from_purchase_page') === window.location.pathname.split('/').pop() &&
          !localStorage.getItem(`invalid_upsell_${props.blockData.render_id}`)
        )
      ) {
        setIsBlockValid(true);
      }

      if(
        props.blockData && 
        props.blockData.purpose === PaymentBlockPurpose.Upsell &&
        props.blockData.upsell_urgency_type &&
        props.blockData.upsell_urgency_type !== UpsellUrgencyType.None &&
        localStorage.getItem('from_purchase_page') === window.location.pathname.split('/').pop() &&
        !localStorage.getItem(`invalid_upsell_${props.blockData.render_id}`)
      ) {
        if(
          props.blockData.upsell_urgency_type === UpsellUrgencyType.Timer &&
          props.blockData.upsell_urgency_value
        ) {
          setTimeout(() => {
            localStorage.setItem(`invalid_upsell_${props.blockData.render_id}`, props.blockData.render_id);
            setIsBlockValid(false);
          }, (Number(props.blockData.upsell_urgency_value) * SECONDS_IN_A_MINUTE * MILLISECONDS_IN_A_SECOND))
        }

        const handleUnload = () => {
          setTimeout(() => {
            localStorage.setItem(`invalid_upsell_${props.blockData.render_id}`, props.blockData.render_id);
            setIsBlockValid(false);
          }, 500);
        };
    
        window.addEventListener("beforeunload", handleUnload);
    
        return () => {
          window.removeEventListener("beforeunload", handleUnload);
        }; 
      }
    }, [props.preview, props.buildingPreview, props.blockData]);

    React.useEffect(() => {
      if(
        props.blockData.resource &&
        props.authedUser
      ) {
        checkIfUserPurchasedResource();
      }
    }, [props.authedUser, props.blockData.resource]);

    React.useEffect(() => {
      if(
        props.blockData.upsell_resources &&
        props.blockData.upsell_resources.length &&
        props.authedUser
      ) {
        checkIfUserPurchasedAnUpsellResource();
      }
    }, [props.authedUser, props.blockData.upsell_resources]);

    React.useEffect(() => {
      if(
        props.blockData.resource_price_option &&
        (
          props.blockData.resource_price_option.amount === "0.00" ||
          props.blockData.resource_price_option.amount == 0
        )
      ) {
        setisFreePlan(true);
      }
    }, [props.blockData.resource_price_option]);

    React.useEffect(() => {
        // Getting browser user-agent.
        const browserInfo = deviceDetect();
        setUa(browserInfo.userAgent);
    
        // Getting IP of user
        (async () => {
          const ipV4 = await publicIp.v4();
          setIp(ipV4);
        })();
        window.scrollTo(0, 0);
    }, []);

    React.useEffect(() => {
      if (
        props.group && 
        props.blockData.resource && 
        props.blockData.resource.sellable_type === SellableTypes.PLAN &&
        props.blockData.resource.sellable
      ) {
        setLoadingTrialDays(true);
        getTrialDays(props.blockData.resource.sellable);
      }
    }, [props.group, props.blockData.resource]);

    React.useEffect(() => {
        if(
            props.blockData.upsell_urgency_type === UpsellUrgencyType.Timer &&
            props.blockData.upsell_urgency_value
        ) {
            setDisplayDate({
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            });
            setSeconds(props.blockData.upsell_urgency_value * SECONDS_IN_A_MINUTE);
        }
    }, [props.blockData]);

    React.useEffect(() => {
        if(
            seconds &&
            props.blockData.upsell_urgency_type === UpsellUrgencyType.Timer
        ) {
            const timeout = setTimeout(() => {
                setDisplayDate(convertSeconds(seconds - 1));
                setSeconds(seconds - 1);
            }, MILLISECONDS_IN_A_SECOND);

            return () => clearTimeout(timeout);
        }
    }, [props.blockData, seconds]);

    const convertSeconds = (seconds: number) => {
        const days = Math.floor(seconds / (24 * 3600));
        const hours = Math.floor((seconds % (24 * 3600)) / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
      
        return { days, hours, minutes: mins, seconds: secs };
    };

    const getTrialDays = (plan: any) => {
      GroupService.getInstance()
        .getUserProratedTrialDays(props.group.id, plan.id)
        .then((response: any) => {
          setTrialDays(response && response.data);
        })
        .catch((error: any) => {
          console.error(error)
          new Error(error)
        })
        .finally(() => setLoadingTrialDays(false))
    }

    const checkIfUserPurchasedResource = () => {
      PricingService.getInstance()
      .checkIfUserPurchasedResources(props.authedUser.id, props.group.id, [
        {
          sellable_type: props.blockData.resource.sellable_type,
          sellable_id: props.blockData.resource.sellable.id,
        },
      ])
      .then((response: any) => {
        if(
          response &&
          response.data
        ) {
          setIsResourcePurchased(response.data.purchased);
        }
      })
      .finally(() => setLoadingIsResourcePurchased(false));
    }

    const checkIfUserPurchasedAnUpsellResource = () => {

      PricingService.getInstance()
      .checkIfUserPurchasedResources(props.authedUser.id, props.group.id, 
        props.blockData.upsell_resources.filter((resource: any) => resource && resource.id).map((resource: any) => ({
          sellable_type: resource.sellable_type,
          sellable_id: resource.id,
      })))
      .then((response: any) => {
        if(
          response &&
          response.data
        ) {
          setIsAnUpsellResourcePurchased(response.data.purchased);
        }
      })
    }

      const skipUpsell = () => {
          if(props.buildingPreview) {
              return;
          }
          
          if(
              props.blockData &&
              (
                !props.blockData.skip_upsell_action ||
                  props.blockData.skip_upsell_action === ButtonAction.URL ||
                  props.blockData.skip_upsell_action === ButtonAction.URLTab
              ) &&
              props.blockData.skip_upsell_url
          ) {
              window.open(
                  miscUtils.ensureHttps(props.blockData.skip_upsell_url),
                  props.blockData.skip_upsell_action === ButtonAction.URLTab ?
                  '_blank' :
                  '_self'
              );
              return;
          }
  
          if(
              props.blockData &&
              props.blockData.skip_upsell_action === ButtonAction.Scroll &&
              props.blockData.skip_upsell_url &&
              props.containerBaseIdName
          ) {
              scrollElementIntoView(`${props.containerBaseIdName}${props.blockData.skip_upsell_url}`);
              return;
          }
  
          if(
              props.blockData &&
              props.blockData.skip_upsell_action === ButtonAction.Popup &&
              props.blockData.skip_upsell_url
          ) {
              let nextPageFormsOpenState = JSON.parse(JSON.stringify(props.pageFormsOpenState));
  
              nextPageFormsOpenState[props.blockData.skip_upsell_url] = true;
  
              props.setPageFormsOpenState(nextPageFormsOpenState);
              return;
          }
  
          if(
              props.blockData &&
              props.blockData.skip_upsell_action === ButtonAction.Page &&
              props.blockData.skip_upsell_url
          ) {
              window.open(
                  `${props.blockData.skip_upsell_url}`, 
                  '_self'
              );
              return;
          }
      }

        const checkForPotentialLandingPageRedirect = (url: string) => {
          if( //is landing page
            url.split('/').length === 5 &&
            url.split('/')[3] === 'pages'
          ) {
            localStorage.setItem('from_purchase_page', (url.split('/').pop() as string))
          }
        }

    const ctaOnClick = (key: string) => {
      if(props.buildingPreview) {
          return;
      }

      if(!isResourcePurchased) {
        if(
          props.blockData &&
          props.blockData[`${key}_action`] !== ButtonAction.Popup
        ) {
          setTimeout(() => {
            setIsResourcePurchased(true);
          }, 2000);
        } else {
          setIsResourcePurchased(true);
        }
      }

      if(
        props.blockData &&
        props.blockData[`${key}_action`] !== ButtonAction.Popup
      ) {
        setTimeout(() => {
          setPurchaseSuccessful(true);
        }, 2000);
      } else {
        setPurchaseSuccessful(true);
      }
  
      if(
          props.blockData &&
          (
			!props.blockData[`${key}_action`] ||
              props.blockData[`${key}_action`] === ButtonAction.URL ||
              props.blockData[`${key}_action`] === ButtonAction.URLTab
          ) &&
          props.blockData[`${key}_url`]
      ) {
          checkForPotentialLandingPageRedirect(miscUtils.ensureHttps(props.blockData[`${key}_url`]));
          window.open(
              miscUtils.ensureHttps(props.blockData[`${key}_url`]), 
              props.blockData[`${key}_action`] === ButtonAction.URLTab ?
              '_blank' :
              '_self'
          );
          return;
      }
  
      if(
          props.blockData &&
          props.blockData[`${key}_action`] === ButtonAction.Scroll &&
          props.blockData[`${key}_url`] &&
          props.containerBaseIdName
      ) {
          scrollElementIntoView(`${props.containerBaseIdName}${props.blockData[`${key}_url`]}`);
          return;
      }
  
      if(
          props.blockData &&
          props.blockData[`${key}_action`] === ButtonAction.Popup &&
          props.blockData[`${key}_url`]
      ) {
          let nextPageFormsOpenState = JSON.parse(JSON.stringify(props.pageFormsOpenState));
  
          nextPageFormsOpenState[props.blockData[`${key}_url`]] = true;
  
          props.setPageFormsOpenState(nextPageFormsOpenState);
          return
      }

      if(
          props.blockData &&
          props.blockData[`${key}_action`] === ButtonAction.Page &&
          props.blockData[`${key}_url`]
      ) {
          checkForPotentialLandingPageRedirect(props.blockData[`${key}_url`]);
          window.open(
            `${props.blockData[`${key}_url`]}`, 
              '_self'
          );
          return;
      }
    }

    const getPaymentData = (paymentData: any) => {
        setPaymentData(paymentData);
    }

    const validateCoupon = () => {
        if (props.blockData.resource) {
          if (couponCode.trim() === "") {
            toast("Please enter a valid coupon code.", {
              type: 'error',
              autoClose: 3000,
              position: "top-center",
              hideProgressBar: true,
              theme: "light"
            });
            return;
          }
    
          setIsValidatingCoupon(true);
    
          if ((props.blockData.resource.sellable_type === SellableTypes.PLAN)) {
            GroupService.getInstance()
              .validateCouponCode(props.group.id, couponCode, props.blockData.resource.sellable.id)
              .then((response: any) => {
                toast("Coupon applied successfully", {
                  type: 'success',
                  autoClose: 2000,
                  position: "top-center",
                  hideProgressBar: true,
                  theme: "light"
                });
                setValidCoupon(response.data);
              }, (error: any) => {
                toast(error.data.message, {
                  type: 'error',
                  autoClose: 3000,
                  position: "top-center",
                  hideProgressBar: true,
                  theme: "light"
                });
                setValidCoupon(null);
              })
              .catch((error: any) => {
                console.error(error)
                new Error(error)
              })
              .finally(() => setIsValidatingCoupon(false))
          } else {
            PricingService.getInstance()
              .validateResourceCoupon(props.group.id, couponCode, props.blockData.resource_price_option.id)
              .then((response: any) => {
                toast("Coupon validated successfully.", {
                  type: 'success',
                  autoClose: 3000,
                  position: "top-center",
                  hideProgressBar: true,
                  theme: "light"
                });
                setValidCoupon({
                  ...response.data,
                  code: couponCode,
                });
                setIsValidatingCoupon(false);
              })
              .catch((error: any) => {
                toast(error.data.message, {
                  type: 'error',
                  autoClose: 3000,
                  position: "top-center",
                  hideProgressBar: true,
                  theme: "light"
                });
                setIsValidatingCoupon(false);
                setValidCoupon(null);
              });
          }
        }
    }

    const removeCoupon = () => {
        setUserMayHaveCoupon(false);
        setValidCoupon(null);
        setCouponCode("");
    }

    const priceExpired = () => {
        return (
            props.blockData.resource_price_option &&
            props.blockData.resource_price_option.access_expire_on &&
            dayjs.utc(props.blockData.resource_price_option.access_expire_on).isBefore(dayjs.utc())
        )
    }

    const disableBuyBtn = () => {
        if(props.buildingPreview || props.preview || isResourcePurchased) {
          return true;
        }

      if (!isHumanVerified.isVerified && turnstileWidgetIsAvailable !== null) return true

        if(
          props.blockData.resource.sellable_type === SellableTypes.EVENT &&
          isPastEvent(props.blockData.resource.sellable)
        ) {
          return true;
        }

        if (makingPurchase || updateCard) {
            return true;
        }

        if (!userId && (!newUserDetails.email || !newUserDetails.full_name || !newUserDetails.password || !miscUtils.validateEmail(newUserDetails.email))) {
            return true;
        }

        if (!isFreePlan &&
            (!(props.blockData.resource.sellable_type === SellableTypes.PLAN) && paymentHiddenOnTrial()) &&
            (!(miscUtils.userHasCardOnFile(props.group)) &&
            (!paymentData || (paymentData && paymentData.error)))) {
            return true;
        }

        if (!isTosChecked) {
            return true
        }

        if(priceExpired()) {
            return true;
        }

        if(userIsOnCurrentPlan()) {
            return true;
        }

        if(miscUtils.isTeamMember(props.group && props.group.user_membership)) {
            return true;
        }
    }

    const computeDiscountedPrice = () => {
        if (props.blockData.resource_price_option) {
            let discountedPrice: number = props.blockData.resource_price_option.amount;
            if (validCoupon.amount_off) {
            discountedPrice = (props.blockData.resource_price_option.amount - validCoupon.amount_off);
            }

            if (validCoupon.percent_off) {
            discountedPrice = (((100 - validCoupon.percent_off) / 100) * props.blockData.resource_price_option.amount);
            }

            if (discountedPrice % 1 === 0) {
            return discountedPrice.toFixed(2).toLocaleString();
            } else {
            return discountedPrice.toFixed(2).toLocaleString();
            }
        }
        return "0.00";
    }

    const computeDiscountDifference = () => {
        if (props.blockData.resource) {
          return (props.blockData.resource_price_option.amount - Number(computeDiscountedPrice().replace(/,/g, ''))).toFixed(2).toLocaleString();
        }
    }

    const getBillingToday = () => {
        if (props.blockData.resource && props.blockData.resource_price_option) {
            return props.blockData.resource_price_option.amount;
        }
    }

    const updateMemberCard = (paymentMethod: any, isSavingCard: any) => {
        GroupService.getInstance()
        .changePaymentMethod(
            props.group.id,
            props.group.user_membership.id,
            paymentMethod.paymentMethod.id
        )
        .then((response: any) => {
            setPaymentData(paymentMethod);
        }).catch((error: any) => {
            console.error(error)
            new Error(error)
        })
    }

    const signUpAndPurchase = async () => {
        setMakingPurchase(true);
        try {
          await AuthorizeService.getInstance()
            .registerUser(newUserDetails as User);
    
          const userString = Cookie.get(CommonConstants.USER_KEY);
          if (userString) {
            const user = JSON.parse(userString);
    
            if (user) {
              userId = user.id;
            }
          }
        } catch (error) {
          setMakingPurchase(false);
          setisHumanVerified({
            isVerified: false,
            session_token: undefined
          });
          turnstile && turnstile.reset();
          setMakingPurchase(false);
          return; // Return early if an error occurs during registration
        }
    
        setTimeout(() => {
          buyResource();
        }, 200);
    }

    const { errors, handleSubmit } = useForm(signUpAndPurchase, newUserDetails);

    const userIsOnCurrentPlan = () => {
        return (
            props.blockData.resource &&
            (
            props.blockData.resource.sellable_type === SellableTypes.PLAN 
            ) &&
            props.group &&
            props.group.user_membership &&
            props.group.user_membership.active_subscription &&
            props.group.user_membership.active_subscription.plan &&
            props.blockData.resource &&
            props.blockData.resource.sellable.id === props.group.user_membership.active_subscription.plan.id &&
            !miscUtils.isSubscriptionPaymentFailedOrPastDue(props.group)
        );
    }

    const paymentHiddenOnTrial = () => {
      if(loadingTrialDays && !makingPurchase) {
        return true;
      }
  
      return (
        (
          props.blockData.resource &&
          props.blockData.resource.sellable_type === SellableTypes.PLAN
        ) &&
        props.blockData.resource &&
        props.blockData.resource.sellable &&
        props.blockData.resource.sellable.trial_days &&
        !props.blockData.resource.sellable.collect_payment_details_on_trial &&
        trialDays
      );
    }

    const shouldPay = (): boolean => {
        return true;
    }

    const login = async () => {
        try {
          // await AuthorizeService.getInstance()
          // .login(newUserDetails.email, newUserDetails.password, ip, ua);
          if (turnstileWidgetIsAvailable === null) {
            await AuthorizeService.getInstance()
              .login(newUserDetails.email, newUserDetails.password, ip, ua, undefined, props.group.id);
          } else {
            await AuthorizeService.getInstance()
              .login(newUserDetails.email, newUserDetails.password, ip, ua, isHumanVerified.session_token, props.group.id);
          }
        } catch (error) {
            toast(`${(error as any).data.message}`, {
            type: 'error',
            autoClose: 2000,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
            });
        }
    }

    const makePurchase = (event: any) => {
        if (props.group && miscUtils.isTeamMember(props.group.user_membership)) {
          toast("You already have access to this content", {
            type: 'error',
            autoClose: 2000,
            position: "top-center",
            hideProgressBar: true,
            theme: "light"
          });
    
          return;
        }
    
    
        if (props.blockData.resource && props.blockData.resource_price_option) {
          if (
              (paymentData && paymentData.paymentMethod) || 
              (props.blockData.resource_price_option.amount == 0) || 
              miscUtils.userHasCardOnFile(props.group) ||
              (props.blockData.resource.sellable_type === SellableTypes.PLAN && paymentHiddenOnTrial())
          ) {
            if (!props.authed) {
              handleSubmit(event);
              return;
            }
    
            if (
              (paymentData && paymentData.paymentMethod) || (
                props.blockData.resource_price_option.amount == 0 ||
                props.blockData.resource_price_option.amount == 0.0 ||
                props.blockData.resource_price_option.amount == 0.00
              ) || miscUtils.userHasCardOnFile(props.group) ||
            (props.blockData.resource.sellable_type === SellableTypes.PLAN && paymentHiddenOnTrial())
            ) {
              if (!props.authed) {
                handleSubmit(event);
                return;
              }
              buyResource();
            }
          }
        }
    } //closing

    const getResourceType = () => {
        switch (props.blockData.resource.sellable_type) {
            case SellableTypes.COURSE:
                return GroupAppResource.COURSE;
            case SellableTypes.EVENT:
                return GroupAppResource.EVENT;
            case SellableTypes.VIDEO:
            case SellableTypes.AUDIO:
            case SellableTypes.PDF:
            case SellableTypes.EMBED:
            case SellableTypes.ARTICLE:
                return props.blockData.resource.sellable_type.slice(0, -1);
            case SellableTypes.PLAN:
                return GroupAppResource.GROUP_PLAN;
            default:
                return null;
        }
    }

    const buyResource = () => {
        if (props.blockData.resource && props.blockData.resource_price_option) {
            let payload: any = {
              resource_type: getResourceType(),
              price_option_id: props.blockData.resource_price_option.id,
              payment_method_id: paymentData && paymentData.paymentMethod ? paymentData.paymentMethod.id : null,
              tos_accepted: isTosChecked,
            }

            if (!!validCoupon) {
              payload.coupon_code = couponCode;
            }

            const _fbc = Cookie.get('_fbc');

            if(_fbc) {
              payload.fbc = _fbc;
            }

            payload.ua = ua;
            payload.ip = ip;

            if (userId && turnstileWidgetIsAvailable !== null) {
              payload.session_token = isHumanVerified.session_token
            }     

            setMakingPurchase(true);

            if (props.blockData.resource.sellable_type === SellableTypes.PLAN) {
                if (!props.group.user_membership) {
                    membershipRequest();
                } else {
                    changeSubscriptionPlan();
                }
            } else {
              PricingService.getInstance()
                .purchaseResource(props.group.id, props.blockData.resource.sellable.id, payload)
                .then(() => {
                Cookie.remove('_fbc', { path: "/", domain: window.location.hostname });
                toast("Checkout successful!", {
                    type: 'success',
                    autoClose: 3000,

                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                });
                setTimeout(() => {
                    setMakingPurchase(false);
                }, 2000);
                ctaOnClick('button');
                })
                .catch((error: any) => {
                  setisHumanVerified({
                    isVerified: false,
                    session_token: undefined
                  });
                  turnstile && turnstile.reset();
                setMakingPurchase(false);
                if (error.status && error.status === 422) {
                    toast(error.data.message, {
                    type: 'error',
                    autoClose: 3000,

                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                    });
                }
                });
            }
        }
    }

    const changeSubscriptionPlan = () => {
        if (props.blockData.resource) {
            const couponToApply = !!validCoupon ? couponCode : "";

            if(miscUtils.isMembershipPendingApproval(props.group && props.group.user_membership)) {
                GroupService.getInstance()
                .updateTempPlan(
                    props.group.id,
                    props.group.user_membership.id,
                    props.blockData.resource.sellable.id,
                    paymentData != null && paymentData.paymentMethod ? paymentData.paymentMethod.id : null,
                    couponToApply,
                    isTosChecked,
                    null
                )
                .then((response: any) => {
                    toast("You have successfully updated your plan.", {
                    type: 'success',
                    autoClose: 3000,

                    position: "top-center",
                    hideProgressBar: true,
                    theme: "light"
                    });
                    ctaOnClick('button');
                })
                .catch((error: any) => {
                    setMakingPurchase(false);
                }).finally(() => {
                });

                return;
            }

            GroupService.getInstance()
            .changeMembershipPlan(
                props.group.id,
                props.group.user_membership.id,
                props.blockData.resource.sellable.id,
                paymentData != null && paymentData.paymentMethod ? paymentData.paymentMethod.id : null,
                couponToApply,
                isTosChecked,
                null
            )
            .then((response: any) => {
                toast("You have successfully updated your plan.", {
                type: 'success',
                autoClose: 3000,

                position: "top-center",
                hideProgressBar: true,
                theme: "light"
                });
                ctaOnClick('button');
            })
            .catch((error: any) => {
                setMakingPurchase(false);
            }).finally(() => {
            });

        }
    }

    const membershipRequest = () => {
        if (props.blockData.resource && props.blockData.resource_price_option) {
            const isFreePlan = (props.blockData.resource_price_option.amount === "0.00" || props.blockData.resource_price_option.amount == 0);

            if (props.group && (paymentData || isFreePlan || paymentHiddenOnTrial())) {
            const couponToApply = !!validCoupon ? couponCode : "";

            const payload: any = {};

            const _fbc = Cookie.get('_fbc');

            if(_fbc) {
                payload.fbc = _fbc;
            }

            payload.ua = ua;
            payload.ip = ip;

            GroupService.getInstance()
                .membershipRequest(
                userId,
                props.group.id,
                paymentData && paymentData.paymentMethod ? paymentData.paymentMethod.id : null,
                props.blockData.resource.sellable.id,
                couponToApply,
                 null,
                isTosChecked,
                payload,
                )
                .then((response: any) => {
                    if(props.refetchGroup) {
                      props.refetchGroup();
                    }
                    Cookie.remove('_fbc', { path: "/", domain: window.location.hostname });
                    ctaOnClick('button');
                })
                .catch((error: any) => {
                  if(props.refetchGroup) {
                    props.refetchGroup();
                  }
                  setisHumanVerified({
                    isVerified: false,
                    session_token: undefined
                  });
                  turnstile && turnstile.reset();
                    if (error.status && error.status === 422) {
                        toast(error.data.message, {
                        type: 'error',
                        autoClose: 3000,

                        position: "top-center",
                        hideProgressBar: true,
                        theme: "light"
                        });
                    }
                }).finally(() => setMakingPurchase(false));
            }
        }
    }

    const changeNewUserDetails = (event: any) => {
        setNewUserDetails({
          ...newUserDetails,
          [event.target.name]: event.target.value,
        });
    }

  React.useEffect(() => {
    if (isHumanVerified.isVerified && isHumanVerified.session_token && turnstileWidgetIsAvailable !== null) {
      setNewUserDetails({
        ...newUserDetails,
        session_token: isHumanVerified.session_token
      })
    }
  }, [isHumanVerified])

    const getUserEmail = () => {
        if (
          props.authedUser &&
          props.authedUser.email
        ) {
          return props.authedUser.email;
        }
    
        return "";
    }

    const purchaseItemIsZeroPriced = () => {
        return (
          props.blockData.resource_price_option &&
          (
            props.blockData.resource_price_option.amount === "0.00" ||
            props.blockData.resource_price_option.amount == 0
          )
        )
    }

    const getPaymentMarkup = () => {
        return (
            <>
            <div
            className="groupapp-resource-checkout-pbp-container"
            >
              <div
              className="groupapp-resource-checkout-pbp-right-container"
              >
                {
                  props.blockData.purpose === PaymentBlockPurpose.Upsell &&
                  props.blockData.upsell_urgency_type === UpsellUrgencyType.Timer &&
                  props.blockData.show_countdown ?
                  (
                    <UpsellTimerContainer
                    design={props.blockData.design}
                    className="groupapp-resource-checkout-pbp-timer-container"
                    >
                      <UpsellTimerIconContainer
                      design={props.blockData.design}
                      className="groupapp-resource-checkout-pbp-timer-icon-container"
                      >
                        <DangerIcon
                        />
                      </UpsellTimerIconContainer>
                      <UpsellTimerText
                      design={props.blockData.design}
                      className="groupapp-resource-checkout-pbp-timer-text"
                      >
                        Offer ends in {" "}
                        <span
                        className="groupapp-resource-checkout-pbp-timer-text highlight"
                        >
                          {displayDate.days}{" "}
                        </span>
                        days
                        {" "}
                        <span
                        className="groupapp-resource-checkout-pbp-timer-text highlight"
                        >
                          {displayDate.hours}{" "}
                        </span>
                        hours
                        {" "}
                        <span
                        className="groupapp-resource-checkout-pbp-timer-text highlight"
                        >
                          {displayDate.minutes}{" "}
                        </span>
                        minutes
                        {" "}
                        <span
                        className="groupapp-resource-checkout-pbp-timer-text highlight"
                        >
                          {displayDate.seconds}{" "}
                        </span>
                        seconds
                      </UpsellTimerText>
                    </UpsellTimerContainer>
                  ) : <></>
                }
                <div
                className="groupapp-resource-checkout-pbp-right-wrapper"
                >
                  <h1
                  className="groupapp-resource-checkout-pbp-right-title"
                  >
                    {props.blockData.purchase_container_title}
                  </h1>
        
                  <div
                  className={`groupapp-resource-checkout-pbp-right-account-info-container ${props.blockData.purchase_container_title && props.blockData.purchase_container_title.trim() === "" ? 'no-margin-top' : ''}`}
                  >
                    {miscUtils.OAuthActivated(props.group && props.group) ? (
                      <></>
                    ) : (
                      <h1
                      className="groupapp-resource-checkout-pbp-right-account-info-title"
                      >
                        Account information
                      </h1>
                    )}

   {
                    props.authed
                    ?
                    <></>
                    :
                     <div
                                className="groupapp-purchase-pbp-account-content-footer-container"
                              >
                                <p
                                  className="groupapp-purchase-pbp-account-content-footer-text"
                                >Already have an account? <span
                                  className="groupapp-purchase-pbp-account-content-footer-highlight"
                                  onClick={() => {
                                    setIsLoginModalOpen(true);
                                  }}
                                >Log in</span></p>
                              </div>
    }
        
                    {props.authed ? (
                      <div
                      className="groupapp-resource-checkout-pbp-right-account-info-authed-container"
                      >
                        <p
                        className="groupapp-resource-checkout-pbp-right-account-info-authed-subtext"
                        >
                          Use this account to access your purchase
                        </p>
    
                        <div
                        className="groupapp-resource-checkout-pbp-right-account-info-authed-account-container"
                        >
                          <p
                          className="groupapp-resource-checkout-pbp-right-account-info-authed-account-text"
                          >
                            You are logged in as {getUserEmail()}
                          </p>
    
                          {/* <button
                          className="groupapp-resource-checkout-pbp-right-account-info-authed-account-action"
                          onClick={() => {
                            
                          }}
                          >
                            Log out
                          </button> */}

                        </div>
                        {/* <TurnstileWidget group={props.group} widgetBodyStyles={'paymentBlockSTyles'} /> */}
                      </div>
                    ) : <></>}
    
                    {!props.authed ? (
                      <div
                      className="groupapp-resource-checkout-pbp-right-account-info-unauthed-container"
                      >
                        <div
                        className="groupapp-purchase-pbp-account-container"
                        >
                          <div className="groupapp-purchase-pbp-account-title-wrapper">
                            <div>
                              <p className="groupapp-purchase-pbp-account-title">
                                {
                                  miscUtils.OAuthActivated(props.group && props.group)
                                    ?
                                    'Log in to your account'
                                    :
                                    `${isCheckingEmailEntered
                                      ? 'Contact info'
                                      :
                                      `${userIsFound
                                        ? 'Log in'
                                        :
                                        'Create your account'}`}`
    
                                }
                              </p>
                              {!isCheckingEmailEntered && userIsFound === 'User found' &&
                                <span className="account-exists-title">
                                  This account already exists. Please log in.
                                </span>
                              }
                              {
                                isCheckingEmailEntered &&
                                <span className='account-subtext'>
                                    Enter your email to log in or create an account.
                                </span>
                              }
                            </div>
                          </div>
    
                          {miscUtils.OAuthActivated(props.group && props.group) ? (
                            <>
                              <div
                                className="groupapp-purchase-pbp-account-content-container oauth"
                              >
                                <Login
                                  nbeaFlow={miscUtils.useNbeaFlow(props.group && props.group)}
                                  OAuthActive
                                  group={props.group}
                                  loginCallback={() => {}}
                                  noTopBorder
                                  purchaseView
                                  onlyLoginAction
                                />
                              </div>
                            </>
                          ) : (
    
                            <div
                              className="groupapp-purchase-pbp-account-content-container"
                            >
  
                              <div
                              className="groupapp-purchase-pbp-account-content-input-container no-margin"
                              >
                              <p
                                  className="groupapp-purchase-pbp-account-content-input-label"
                                  >Email address<span className='required'>*</span></p>
                              <input
                                  type="email"
                                  name="email"
                                  form-datatype='email'
                                  value={newUserDetails.email}
                                  onChange={changeNewUserDetails}
                                  placeholder="Enter email address"
                                  className="groupapp-purchase-pbp-account-content-input-field"
                              />
                              <div
                                  className="groupapp-purchase-pbp-account-content-input-error-container"
                              >{errors.email && errors.email.errorComponent}</div>
                              </div>
                              {showNameInput &&
                                <div
                                  className="groupapp-purchase-pbp-account-content-input-container "
                                >
                                  <p
                                    className="groupapp-purchase-pbp-account-content-input-label"
                                    >Full name<span className='required'>*</span></p>
                                  <input
                                    type="text"
                                      form-datatype='text'
                                    name="full_name"
                                    value={newUserDetails.full_name}
                                    onChange={changeNewUserDetails}
                                    placeholder="Enter full name"
                                    className="groupapp-purchase-pbp-account-content-input-field"
                                  />
                                  <div
                                    className="groupapp-purchase-pbp-account-content-input-error-container"
                                  >{errors.full_name && errors.full_name.errorComponent}</div>
                                </div>
                              }
    
                              {!isCheckingEmailEntered && (userIsFound === 'User found' || showNameInput) &&
                                <div
                                  className="groupapp-purchase-pbp-account-content-input-container"
                                >
                                    <p className="groupapp-purchase-pbp-account-content-input-label">
                                      Password
                                      <span className='required'>*</span>
                                    </p>
                                    <input
                                      type="password"
                                      form-datatype='password'
                                      name="password"
                                      value={newUserDetails.password}
                                      onChange={changeNewUserDetails}
                                      placeholder="********"
                                      className="groupapp-purchase-pbp-account-content-input-field"
                                      autoComplete={showNameInput ? 'Off' : 'On'}
                                    />
                                  <div
                                    className="groupapp-purchase-pbp-account-content-input-error-container"
                                  >{errors.password && errors.password.errorComponent}</div>
                                </div>
                              }
    
                              {!isCheckingEmailEntered && userIsFound === 'User found' &&
                                  <div className="account-exists">
                                    <div className='account-exists-middle'>
                                      <Button theme={communityTheme} onClick={login} label="Log In" />
    
                                    <Link
                                      className='forgot'
                                      to="/forgot-password">
                                      <span>
                                        Forgot Password
                                      </span>
                                    </Link>
                                  </div>
                                </div>
                              }
    
                                {/* {
                                  props.group &&
                                  <TurnstileWidget group={props.group && props.group} widgetBodyStyles={'paymentBlockSTyles'} />
                                } */}

                              {/* <div
                                className="groupapp-purchase-pbp-account-content-footer-container"
                              >
                                <p
                                  className="groupapp-purchase-pbp-account-content-footer-text"
                                >Already have an account? <span
                                  className="groupapp-purchase-pbp-account-content-footer-highlight"
                                  onClick={() => {
                                    setIsLoginModalOpen(true);
                                  }}
                                >Log in</span></p>
                              </div> */}
                            </div>
    
                          )}
                        </div>
                      </div>
                    ) : <></>}
                    <PurchaseLoginModal
                      isOpen={isLoginModalOpen}
                      group={props.group}
                      close={() => {
                        setIsLoginModalOpen(false);
                      }}
                      ua={ua}
                      ip={ip}
                    />
                  </div>
    
    
                  {!(!props.authed && miscUtils.OAuthActivated(props.group && props.group)) ? (
                      <div
                        className="groupapp-purchase-pbp-payment-container"
                      >
                        {(shouldPay() && !paymentHiddenOnTrial()) &&
                          props.blockData.resource &&
                          props.blockData.resource.sellable &&
                          props.blockData.resource.sellable.price &&
                          props.blockData.resource_price_option &&
                          props.blockData.resource_price_option.amount !== "0.00" ? (
                            <div className='groupapp-purchase-pbp-payment-container-middle'>
                              <p
                                className="groupapp-purchase-pbp-payment-title"
                              >
                                Payment information
                              </p>
    
                              <p
                                className="groupapp-purchase-pbp-order-summary-subtext"
                              >Secure payments powered by Stripe</p>
    
                              <div
                                className="groupapp-purchase-pbp-payment-content-container"
                              >
    
                            {
                              props.blockData.resource &&
                              props.blockData.resource.sellable && 
                              props.blockData.resource.sellable.price && 
                              props.blockData.resource_price_option.amount > 0 ? (
                                  <div
                                    className="groupapp-purchase-pbp-payment-content-input-container"
                                  >
                                    <div
                                      className="groupapp-purchase-pbp-payment-content-input-label-container"
                                    >
                                      <p
                                        className="groupapp-purchase-pbp-payment-content-input-label-text"
                                      >Card details <span className='required'>*</span></p>
                                      <div
                                        className="groupapp-purchase-pbp-payment-content-input-label-icons-container"
                                      >
                                        <span
                                        className='groupapp-purchase-pbp-payment-content-input-label-icons-unit'
                                        >
                                          <MasterCardIcon />
                                        </span>
    
                                        <span
                                          className='groupapp-purchase-pbp-payment-content-input-label-icons-unit'
                                        >
                                          <VisaIcon />
                                        </span>
    
                                        <span
                                          className='groupapp-purchase-pbp-payment-content-input-label-icons-unit'
                                        >
                                          <AmexIcon />
                                        </span>
    
                                        <span
                                          className='groupapp-purchase-pbp-payment-content-input-label-icons-unit'
                                        >
                                          <DiscoverIcon />
                                        </span>
    
                                        <span
                                          className='groupapp-purchase-pbp-payment-content-input-label-icons-unit'
                                        >
                                          <DinersClubIcon />
                                        </span>
                                      </div>
                                    </div>
                                    {!updateCard && miscUtils.userHasCardOnFile(props.group) && !miscUtils.isSubscriptionPaymentFailedOrPastDue(props.group) ? (
                                      <PaymentDetails
                                        group={props.group}
                                        paymentData={paymentData}
                                        onUpdateCard={() => {
                                          setUpdateCard(true);
                                        }}
                                      />
                                    ) : (
                                      <div
                                        className="groupapp-purchase-pbp-payment-content-input-field-container"
                                      >
                                        <StripeProvider
                                          apiKey={appConfig.stripe.public_key}
                                          stripeAccount={props.group.stripe_connect_user_id}
                                        >
                                          <Elements>
                                            <PlanSelectionStripeForm
                                              userEmail={props.authedUser && props.authedUser.email}
                                              updateInfo={() => setUpdateCard(!updateCard)}
                                              getPayData={getPaymentData}
                                              group={props.group}
                                              isUpdate={updateCard}
                                              updateMemberCard={updateMemberCard}
                                            />
                                          </Elements>
                                        </StripeProvider>
                                      </div>
                                    )}
                                  </div>
                                ) : (<></>)}
                              </div>
                            </div>
                          ) : <></>}
                      </div>
                    ) : <></>}
    
                  {
                    shouldPay() && 
                    props.blockData.resource &&
                    props.blockData.resource.sellable ? (
                      <div className='groupapp-purchase-pbp-order-summary-container'>
                        <p
                          className="groupapp-purchase-pbp-order-summary-title"
                        >
                          Order summary
                        </p>
    
                        <div
                          className="groupapp-purchase-pbp-order-summary-content-container"
                        >
                          <div className='groupapp-purchase-pbp-order-summary-content-details'>
                            <div>
                              {props.blockData.resource.sellable && (props.blockData.resource.sellable.name || props.blockData.resource.sellable.title)}
                            </div>
                            <div>
                              {
                              purchaseItemIsZeroPriced() ?
                                  <span>
                                    Free
                                  </span> :
                                  <span>
                                    {
                                      miscUtils.getCurrencySymbol(
                                        props.blockData.resource &&
                                        props.blockData.resource.sellable && 
                                        props.blockData.resource_price_option &&
                                        props.blockData.resource_price_option.currency
                                      )
                                    }
                                    {
                                      props.blockData.resource &&
                                      props.blockData.resource.sellable && 
                                      props.blockData.resource_price_option &&
                                      props.blockData.resource_price_option.amount
                                    }
                                  </span>
                              }
    
                              {/* Plan interval for group subscriptions */}
                              {(props.blockData.resource.sellable_type === SellableTypes.PLAN) ? (
                                <span>
                                  {miscUtils.getPlanInterval(props.blockData.resource.sellable ? props.blockData.resource.sellable : undefined)}
                                </span>
                              ) : <></>}
                            </div>
                          </div>
    
                          {/* Trial starting date if trial */}
                          {
                            props.blockData.resource.sellable_type === SellableTypes.PLAN &&
                            trialDays &&
                            !Boolean(!!validCoupon) ?
                            (
                              <>
                                {/* Trial period */}
                                <div className='groupapp-purchase-pbp-order-summary-content-trial'>
                                  <div>
                                    Trial period {miscUtils.userIsOnTrial(props.group) ? "left" : ""}
                                  </div>
                                  <div>
                                    <span>
                                      {trialDays} {trialDays === 1 ? "day" : "days"}
                                    </span>
                                  </div>
                                </div>
                              </>
                            ) : <></>
                          }
    
                          {/* Valid coupon applied */}
                          {!!validCoupon && (
                          <>
                            <p
                              className={`groupapp-purchase-pbp-order-summary-content-discount`}
                            >
                              <span className="discount-label">Discount applied</span>
                              <span className="discount-value"> -{miscUtils.getCurrencySymbol(props.blockData.resource.sellable && props.blockData.resource_price_option.currency)}{computeDiscountDifference()}</span>
                            </p>
                            <p
                              className={`groupapp-purchase-pbp-order-summary-content-discount`}
                            >
                              <span className="discount-label">Coupon duration</span>
                              <span className="discount-value">
                                {
                                  validCoupon.duration === 'repeating' ? validCoupon.duration_in_months + " months" : validCoupon.duration
                                }
                              </span>
                            </p>
                          </>
    
                          )}
                          <div className='groupapp-purchase-pbp-order-summary-content-footer'>
                            <div className='groupapp-purchase-pbp-order-summary-content-footer-total-billed'>
                              <h3>
                                Total amount billed today
                              </h3>
                              {
                                !!validCoupon ? (
                                  <h3
                                  >{
                                    miscUtils.getCurrencySymbol(
                                      props.blockData.resource &&
                                      props.blockData.resource.sellable && 
                                      props.blockData.resource_price_option &&
                                      props.blockData.resource_price_option.currency
                                    )
                                    }{computeDiscountedPrice()}</h3>
                                ) : (
                                  <h3
                                  >{
                                      miscUtils.getCurrencySymbol(
                                        props.blockData.resource &&
                                        props.blockData.resource.sellable && 
                                        props.blockData.resource_price_option &&
                                        props.blockData.resource_price_option.currency
                                      )
                                    }{getBillingToday()
                                    }
                                  </h3>
                                )
                              }
                            </div>
                          </div>
    
                          {/* Coupon area */}
                          <div
                            className="groupapp-purchase-pbp-order-summary-content-coupon-container"
                          >
                            {!userMayHaveCoupon ? (
                              <p
                                className="groupapp-purchase-pbp-order-summary-content-coupon-trigger"
                                onClick={() => {
                                  setUserMayHaveCoupon(true);
                                }}
                              >Have a promo code?</p>
                            ) : (
                              <>
                                <div
                                  className="groupapp-purchase-pbp-order-summary-content-coupon-input-container"
                                >
                                  <input
                                    type="text"
                                      form-datatype='text'
                                    className="groupapp-purchase-pbp-order-summary-content-coupon-input-field"
                                    placeholder="Enter coupon code"
                                    value={couponCode}
                                    onChange={(e: any) => setCouponCode(e.target.value)}
                                  />
                                  <button
                                    className="groupapp-purchase-pbp-order-summary-content-coupon-input-action"
                                    disabled={isValidatingCoupon}
                                    onClick={() => {
                                      if (!!validCoupon) {
                                        removeCoupon();
                                      } else {
                                        validateCoupon();
                                      }
                                    }}
                                    style={miscUtils.customThemeSet(communityTheme) ? {
                                      border: `1px solid ${communityTheme.custom.primaryColor}`,
                                      color: communityTheme.custom.primaryColor,
                                    } : {}}
                                  >
                                    {isValidatingCoupon ? 'Validating...' : !!validCoupon ? 'Remove Code' : 'Apply Code'}
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : <></>}
                     {
                                  props.group &&
                                  <TurnstileWidget group={props.group && props.group} widgetBodyStyles={'paymentBlockSTyles'} />
                                }


    
                  {/* Terms of service */}
                  {!(!props.authed && 
                  miscUtils.OAuthActivated(props.group && props.group)) && 
                  !userIsOnCurrentPlan() && 
                  !(miscUtils.isTeamMember(props.group && props.group.user_membership)) ? (
                    <>
    
                    <div className="groupapp-purchase-pbp-payment-content-terms">
                      <div className='input-check'>
                        <input
                          onChange={() => setIsTosChecked(!isTosChecked)}
                          checked={isTosChecked}
                          name="terms_of_service"
                          type="checkbox"
                          aria-label="Accept terms of service."
                        />
                      </div>
    
                      <p className="footnote">
                        I agree to GroupApp's {" "}
                        <span
                          onClick={() => {
                            window.open('https://www.group.app/terms-of-service/', '_blank');
                          }}
                        >
                          terms of service, {" "}
                        </span>
                        <span
                          onClick={() => {
                            window.open('https://www.group.app/privacy-policy/', '_blank');
                          }}
                        >
                          privacy policy
                        </span>
                        {
                          props.group && props.group.custom_tos !== null ?
                            <>
                              {" "} and  {props.group.name}'s {" "}
                              <span
                                onClick={() => {
                                  window.open(`${props.group.custom_tos}`, '_blank');
                                }}
                              >
                                terms.
                              </span>
                            </>
                            :
                            <span>.</span>
                        }
                      </p>
                    </div>
                    </>
                  ) : <></>}
    
                    {/* Buy now */}
                    {!(!props.authed && miscUtils.OAuthActivated(props.group && props.group)) ? (
                      <>
    
                          {/* Buy now */}
                          {(!updateCard) && (
                          <div
                            className="groupapp-purchase-pbp-payment-content-footer-container"
                          >
    
                            <BlockButton
                              design={props.blockData.design}
                              pageStyles={props.pageStyles}
                              className={`groupapp-purchase-pbp-payment-content-submit ${props.view} ${disableBuyBtn() && !props.buildingPreview ? 'not-allowed' : ''}`}
                              onClick={makePurchase}
                              disabled={disableBuyBtn()}
                            >
                              {userIsOnCurrentPlan() && !(props.buildingPreview || props.preview)? 'Current plan' : isResourcePurchased && !(props.buildingPreview || props.preview) ? 'Purchased' : makingPurchase ? 'Processing...' : props.blockData.button_text}
                            </BlockButton>

                            {props.blockData.purpose === PaymentBlockPurpose.Upsell ? (
                              <SkipUpsellContainer
                              >
                                <SkipUpsellText
                                design={props.blockData.design}
                                onClick={skipUpsell}
                                >
                                  {props.blockData.skip_upsell_text || 'No Thanks'}
                                </SkipUpsellText>
                              </SkipUpsellContainer>
                            ) : <></>}
    
                          </div>
                        )}
                      </>
                  ) : <></>}
                </div>
              </div>
            </div>
            <PurchaseLoginModal
                isOpen={isLoginModalOpen}
                group={props.group}
                close={() => {
                setIsLoginModalOpen(false);
                }}
                ua={ua}
                ip={ip}
            />
          </>
        )
    }

    const checkIfPlanIsAuthorized = () => {
      return (
        props.group &&
        props.group.active_subscription &&
        props.group.active_subscription.plan &&
        props.group.active_subscription.plan.landing_page_payment_block
      )
    }

    const getPurchaseSuccessfulMarkup = () => {
      return (
        <div
        className="payment-block-preview-success-container"
        >
          <span
          className="payment-block-preview-success-icon-container"
          >
            <CheckIcon
            />
          </span>

          <h1
          className="payment-block-preview-success-title"
          >
            {props.blockData.payment_successful_title ? props.blockData.payment_successful_title : 'Transaction completed successfully'}
          </h1>

          <BlockSubTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="subtext"
          fallbackTextColor="#000000"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.payment_successful_subtext || '<p>Thank you for your payment</p>'),
          }}
          />
        </div>
      )
    }

    const getPurchaseInvalidlMarkup = () => {
      return (
        <div
        className="payment-block-preview-success-container"
        >
          <span
          className="payment-block-preview-success-icon-container"
          >
            <UnavailableIcon
            />
          </span>

          <h1
          className="payment-block-preview-success-title"
          >
            {props.blockData.payment_invalid_title ? props.blockData.payment_invalid_title : 'Purchase unavailable'}
          </h1>

          <BlockSubTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="subtext"
          fallbackTextColor="#000000"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.payment_invalid_subtext || '<p>This product is no longer on sale</p>'),
          }}
          />
        </div>
      )
    }

    if(
      loadingIsResourcePurchased ||
      (
        !checkIfPlanIsAuthorized() &&
        !props.preview &&
        !props.buildingPreview
      )
    ) {
      return <></>
    }

    const getBlockContent = () => {
      if(
        props.previewPaymentInvalid ||
        !isBlockValid ||
        (
          props.blockData.purpose === PaymentBlockPurpose.Upsell &&
          !isAnUpsellResourcePurchased &&
          !props.preview &&
          !props.buildingPreview
        )
      ) {
        return getPurchaseInvalidlMarkup();
      }

      if(
        props.previewPaymentSuccessful || 
        (
          !props.preview &&
          !props.buildingPreview &&
          (
            purchaseSuccessful || 
            isResourcePurchased
          )
        )
      ) {
        return getPurchaseSuccessfulMarkup();
      }

      return getPaymentMarkup();
    }

  return (
    <BlockContainer
    design={props.blockData.design}
    >
        <BlockContentContainer
        className={`${props.view ? props.view : ''}`}
        design={props.blockData.design}
        >
          <BlockTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="heading"
          fallbackTextColor="#000000"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.heading),
          }}
          />

          <BlockSubTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="subtext"
          fallbackTextColor="#000000"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.text),
          }}
          />

          {getBlockContent()}
        </BlockContentContainer>
    </BlockContainer>
  )
}

export default PaymentBlockPreview;